module.exports = __webpack_public_path__ + "images/emoji/cat2.b0667b89ab1f16b41bcf.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/cat2.png
// module id = C+vr
// module chunks = 24